import { cx } from '@emotion/css';
import React from 'react';
import { useCheckMarkStyles } from './CheckMark.styles';
export function CheckMark(props) {
    const styles = useCheckMarkStyles();
    if (props.checked) {
        return (React.createElement("div", { className: cx(props.className, styles.complete), id: props.id },
            React.createElement("i", { className: `material-icons ${styles.materialIcon}` }, "done")));
    }
    return React.createElement("div", { className: styles.notComplete });
}
//# sourceMappingURL=CheckMark.js.map